import React from "react";
import { Row, Col, Button } from "antd";
import "../../../../../../../assets/forgotAndResetPassWordModal.scss";
import darkImg from "../../../../../../../assets/images/survey-dark-theme.png";
import lightImg from "../../../../../../../assets/images/survey-light-theme.png";
import { useTranslation } from "react-i18next";
import "../../../../../../../assets/personalCenter.scss";

const ChangeAppearanceModalRender = ({ handleChangeTheme, theme, changeAppearanceSubmitting, handleSubmitChangeAppearance }) => {
	const { t } = useTranslation(["personalCenterSetting"]);
  return (
    <div className="appearance-modal p-md-4 p-0">
      <h4 className="fw-bold mb-5 text-center">{t("appearanceTitle")}</h4>
      <Row gutter={[16, 28]} className="mb-5">
        <Col span={24} md={12}>
          <div
            onClick={() => handleChangeTheme("light")}
            className={`d-flex flex-column align-items-center justify-content-center position-relative ${theme === "light" ? "active" : ""}`}
          >
            <img className="mw-100" src={lightImg} alt="light" />
            <span>{t("appearanceLightMode")}</span>
          </div>
        </Col>
        <Col span={24} md={12}>
          <div
            onClick={() => handleChangeTheme("dark")}
            className={`d-flex flex-column align-items-center justify-content-center position-relative ${theme === "dark" ? "active" : ""}`}
          >
            <img className="mw-100" src={darkImg} alt="dark" />
            <span>{t("appearanceDarkMode")}</span>
          </div>
        </Col>
      </Row>
      <Button type="primary" size="large" className="mx-auto d-block" loading={changeAppearanceSubmitting} onClick={handleSubmitChangeAppearance}>
        {t("common:confirm")}
      </Button>
    </div>
  );
};

export default ChangeAppearanceModalRender;
